export const SET_USER = 'SET_USER';
export const SET_USERS = 'SET_USERS';
export const SET_USERS_QUERY_PARAMS = 'SET_USERS_QUERY_PARAMS';
export const SET_USERS_SET_IS_FETCHING = 'SET_USERS_SET_IS_FETCHING';
